import { Box } from '@vouched.id/vault';
import React, { useMemo } from 'react';
import { Tooltips } from '../../tooltips';
import { itemHasErrorOrWarning } from '../../utils';
import { Dropdown } from '../Dropdown';
import { DropdownItemsSection } from '../DropdownItemsSection';
import { buildDeviceData, buildSubmittedData, IDVDetailsTable } from '../IdDocument/IDVDetailsTable';
import { addIconsToDropdownItems, DropdownItemTypes, DropdownStatusIcon } from '../utils';
import { getRejReasonsNamesAndDescriptions, IdDocumentItemTitle, SELFIE_PENALTY_KEYS } from 'components/account/jobs-v2/dropdowns/IdDocument/utils';
import { IdvError } from 'models/jobs/jobs';
export const SelfieVerificationCompletedResult = ({ jobResult, jobErrors, jobStatus, jobRequestParams, jobRequestInfo, jobRequestProperties, rejectionReasons }) => {
    const selfieConfidence = jobResult.confidences?.selfie;
    const livenessPerformedConfidence = jobResult.confidences?.liveness;
    const { dropdownHasWarnings, dropdownHasRejections, dropdownItems } = useMemo(() => {
        const dropdownItemsWithoutIcons = [
            {
                text: IdDocumentItemTitle.ValidSelfie,
                type: DropdownItemTypes.ConfidenceDropdownItem,
                available: typeof selfieConfidence === 'number',
                hasErrorOrWarning: itemHasErrorOrWarning(jobErrors, IdvError.InvalidUserPhotoError),
                tooltip: Tooltips.ValidSelfie,
                penalties: getRejReasonsNamesAndDescriptions(rejectionReasons, SELFIE_PENALTY_KEYS)
            },
            {
                text: IdDocumentItemTitle.SelfieLivenessPerformed,
                type: DropdownItemTypes.ConfidenceDropdownItem,
                available: typeof livenessPerformedConfidence === 'number',
                hasErrorOrWarning: itemHasErrorOrWarning(jobErrors, IdvError.LivenessSkippedError),
                tooltip: Tooltips.SelfieLivenessPerformed
            }
        ];
        return addIconsToDropdownItems(dropdownItemsWithoutIcons);
    }, [
        jobErrors,
        itemHasErrorOrWarning,
        addIconsToDropdownItems,
        selfieConfidence,
        livenessPerformedConfidence,
        rejectionReasons
    ]);
    const deviceData = buildDeviceData(jobResult, jobRequestInfo);
    const submittedData = buildSubmittedData(jobRequestParams);
    return (React.createElement(Dropdown, { statusIcon: React.createElement(DropdownStatusIcon, { dropdownHasRejections: dropdownHasRejections, dropdownHasWarnings: dropdownHasWarnings, parentJobStatus: jobStatus }), title: "Selfie Verification" },
        React.createElement(Box, null,
            React.createElement(DropdownItemsSection, { dropdownItems: dropdownItems }),
            jobRequestParams && (React.createElement(IDVDetailsTable, { deviceData: deviceData, properties: jobRequestProperties ?? null, submittedData: submittedData })))));
};
